// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"962e465b3b26eed45a67","293":"8c8bb149ead9eef7ebf3"}[chunkId] + ".js";
};